(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('trust-card-carousel')) {
    customElements.define(
      'trust-card-carousel',
      class TrustCardCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.product__trust-track');
          this.cards = Array.from(this.querySelectorAll('.product__trust-card'));
          this.index = 0;
          this.speed = Number(this.dataset.autoplaySpeed) || 4000;

          if (!this.track || this.cards.length < 2) return;

          this.start();
          this.addEventListener('mouseenter', this.stop.bind(this));
          this.addEventListener('mouseleave', this.start.bind(this));
          this.addEventListener('focusin', this.stop.bind(this));
          this.addEventListener('focusout', this.start.bind(this));
        }

        disconnectedCallback() {
          this.stop();
        }

        start() {
          this.stop();
          this.timer = window.setInterval(() => this.next(), this.speed);
        }

        stop() {
          if (!this.timer) return;
          window.clearInterval(this.timer);
          this.timer = null;
        }

        next() {
          this.index = (this.index + 1) % this.cards.length;
          this.track.style.transform = `translateX(-${this.index * 100}%)`;
        }
      }
    );
  }

  const syncProductThumbnailHeights = () => {
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');

      if (!viewer) return;

      gallery.style.setProperty('--product-media-viewer-height', `${viewer.getBoundingClientRect().height}px`);
    });
  };

  window.addEventListener('load', syncProductThumbnailHeights);
  window.addEventListener('resize', syncProductThumbnailHeights);
  document.addEventListener('shopify:section:load', syncProductThumbnailHeights);
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.variantChange, () => window.setTimeout(syncProductThumbnailHeights, 100));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-padel-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-trust-carousel')) {
    customElements.define(
      'hero-trust-carousel',
      class HeroTrustCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.premium-home__hero-trust-track');
          this.items = Array.from(this.querySelectorAll('.premium-home__trust-item'));
          this.index = 0;
          this.speed = Number(this.dataset.autoplaySpeed) || 4000;
          this.media = window.matchMedia('(max-width: 749px)');
          this.handleMediaChange = this.update.bind(this);
          this.startX = 0;
          this.currentX = 0;
          this.isDragging = false;
          this.isMobileActive = false;

          this.media.addEventListener('change', this.handleMediaChange);
          this.addEventListener('pointerdown', this.onPointerDown.bind(this));
          this.addEventListener('pointermove', this.onPointerMove.bind(this));
          this.addEventListener('pointerup', this.onPointerUp.bind(this));
          this.addEventListener('pointercancel', this.onPointerUp.bind(this));
          this.update();
        }

        disconnectedCallback() {
          this.stop();
          this.media?.removeEventListener('change', this.handleMediaChange);
        }

        update() {
          this.stop();

          if (!this.track) return;

          this.isMobileActive = this.media.matches && this.items.length > 1;

          if (!this.isMobileActive) {
            this.index = 0;
            this.track.style.transform = 'translateX(0)';
            return;
          }

          this.goTo(Math.min(this.index, this.items.length - 1));
          this.start();
        }

        next() {
          this.index = (this.index + 1) % this.items.length;
          this.goTo(this.index);
        }

        previous() {
          this.index = (this.index - 1 + this.items.length) % this.items.length;
          this.goTo(this.index);
        }

        goTo(index) {
          this.index = index;
          this.track.style.transition = 'transform 450ms ease';
          this.track.style.transform = `translateX(-${this.getStep() * this.index}px)`;
        }

        getStep() {
          const item = this.items[this.index] || this.items[0];
          const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;

          return item ? item.getBoundingClientRect().width + gap : this.getBoundingClientRect().width;
        }

        onPointerDown(event) {
          if (!this.media.matches || this.items.length < 2) return;

          this.isDragging = true;
          this.startX = event.clientX;
          this.currentX = event.clientX;
          this.stop();
          this.track.style.transition = 'none';
          this.setPointerCapture?.(event.pointerId);
        }

        onPointerMove(event) {
          if (!this.isDragging) return;

          this.currentX = event.clientX;
          const delta = this.currentX - this.startX;
          const offset = -this.getStep() * this.index + delta;

          this.track.style.transform = `translateX(${offset}px)`;
        }

        onPointerUp() {
          if (!this.isDragging) return;

          const delta = this.currentX - this.startX;
          const threshold = Math.max(40, this.getBoundingClientRect().width * 0.18);
          this.isDragging = false;

          if (delta <= -threshold) {
            this.next();
          } else if (delta >= threshold) {
            this.previous();
          } else {
            this.goTo(this.index);
          }

          this.start();
        }

        start() {
          this.stop();

          if (!this.isMobileActive) return;

          this.timer = window.setInterval(() => this.next(), this.speed);
        }

        stop() {
          if (!this.timer) return;

          window.clearInterval(this.timer);
          this.timer = null;
        }
      }
    );
  }

  if (!customElements.get('product-carousel')) {
    customElements.define(
      'product-carousel',
      class ProductCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.premium-home__product-track');
          this.featured = this.closest('.premium-home__featured');
          this.previousButton = this.featured?.querySelector('.premium-home__carousel-button--prev');
          this.nextButton = this.featured?.querySelector('.premium-home__carousel-button--next');

          this.previousButton?.addEventListener('click', () => this.move(-1));
          this.nextButton?.addEventListener('click', () => this.move(1));
          this.track?.addEventListener('scroll', () => this.updateButtons(), { passive: true });
          window.addEventListener('resize', this.updateButtons.bind(this));
          this.updateButtons();
        }

        move(direction) {
          if (!this.track) return;

          const slide = this.track.querySelector('.premium-home__product-slide');
          const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
          const amount = slide ? slide.getBoundingClientRect().width + gap : this.track.clientWidth;

          this.track.scrollBy({
            left: amount * direction,
            behavior: 'smooth',
          });
        }

        updateButtons() {
          if (!this.track || !this.previousButton || !this.nextButton) return;

          const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
          this.previousButton.disabled = this.track.scrollLeft <= 1;
          this.nextButton.disabled = this.track.scrollLeft >= maxScroll;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-conversion-content"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('conversion-story')) {
    customElements.define(
      'conversion-story',
      class ConversionStory extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-show-more]');

          if (!this.button) return;

          this.button.addEventListener('click', this.toggle.bind(this));
        }

        toggle() {
          const expanded = this.dataset.expanded === 'true';
          this.dataset.expanded = expanded ? 'false' : 'true';
          this.button.querySelector('[data-label-more]').hidden = !expanded;
          this.button.querySelector('[data-label-less]').hidden = expanded;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
